@if (rows().length > 0) {
    <div class="submap-tree">
        <!--
            The search box only appears above the engine's value ceiling. Below it one call holds every folder,
            so a box that narrows a complete list would be a control with nothing to do.
        -->
        @if (truncated()) {
            <p class="submap-tree__limit">{{ "facets.submap.limit" | translate: { count: requestedValueCount() } }}</p>
            <ng-container [ngTemplateOutlet]="searchBox" [ngTemplateOutletContext]="{ row: null, label: 'facets.submap.search' | translate }"></ng-container>
        }
        <ul class="submap-tree__level" role="tree">
            <ng-container [ngTemplateOutlet]="level" [ngTemplateOutletContext]="{ $implicit: rows() }"></ng-container>
        </ul>
    </div>
}

<ng-template #level let-rows>
    @for (row of rows; track row.key) {
        <li class="submap-tree__row" role="treeitem" [attr.aria-expanded]="row.expandable ? row.expanded : null" [attr.aria-selected]="row.selected">
            <div class="submap-tree__row__content">
                <!--
                    A folder the budget left closed still shows its chevron and its count: a budget that hid
                    the existence of a subtree would be the very defect this filter exists to fix.
                -->
                @if (row.expandable) {
                    <button
                        type="button"
                        class="submap-tree__chevron"
                        [class.submap-tree__chevron--expanded]="row.expanded"
                        [attr.aria-label]="'facets.submap.toggle' | translate: { folder: row.node.segment }"
                        (click)="onToggleExpanded(row)"
                    ></button>
                } @else {
                    <span class="submap-tree__chevron submap-tree__chevron--placeholder"></span>
                }
                <div class="sh-form-check submap-tree__check">
                    <input
                        type="checkbox"
                        class="sh-form-check__input sh-radio"
                        [id]="inputId(row)"
                        [name]="'submap_' + facetKey()"
                        [value]="row.node.segment"
                        [checked]="row.selected"
                        (change)="onToggleSelected(row)"
                    />
                    <label
                        class="sh-form-check__label submap-tree__label"
                        [class.submap-tree__label--included]="row.included"
                        [for]="inputId(row)"
                        [title]="row.key"
                    >
                        <span class="submap-tree__label__text">{{ row.node.segment }}</span>
                        <span class="submap-tree__label__count">({{ row.node.count }})</span>
                    </label>
                </div>
            </div>
            @if (row.expandable && row.expanded) {
                <ul class="submap-tree__level" role="group">
                    @if (truncated()) {
                        <li class="submap-tree__row" role="none">
                            <ng-container
                                [ngTemplateOutlet]="searchBox"
                                [ngTemplateOutletContext]="{
                                    row: row,
                                    label: 'facets.submap.search-in' | translate: { folder: row.node.segment }
                                }"
                            ></ng-container>
                        </li>
                    }
                    <ng-container [ngTemplateOutlet]="level" [ngTemplateOutletContext]="{ $implicit: row.children }"></ng-container>
                </ul>
            }
        </li>
    }
</ng-template>

<!-- One box, two places: the root level and every open folder narrow their level the same way. -->
<ng-template #searchBox let-row="row" let-label="label">
    <input
        type="search"
        class="sh-form-input submap-tree__search"
        [attr.aria-label]="label"
        [placeholder]="'facets.submap.search' | translate"
        (input)="onSearch(row, $event)"
    />
</ng-template>
